module.exports = __webpack_public_path__ + "img/home.b0c2caca.png";